export default {
    numeroPassaporte: 'Passport or ID number',
    nome: 'Name',
    nomeCompleto: 'Full Name',
    nacionalidade: 'Nationality',
    nascimento: 'Date of Birth',
    email: 'Email',
    telefone: 'Phone Number',
    informarContatoEmergencia: 'Provide emergency contact info?',
    informarRestricoesDadosSaude: 'Provide health restrictions and data?',
    restriçõesDadosSaude: 'Restrictions and Health Data',
    menoresIdade: 'For children under 14 years of age, Accidental Death coverage will be limited to reimbursement of funeral expenses.',
    autorizacao: `I authorize the use of my personal data for the issuance of the Adventure Insurance, and I declare that I am aware and have been informed by the event promoter of the risks involved in tourism and adventure sports activities.`
}